export default {
  LOAD_STREAM (state, payload) {
    state.stream = payload
  },
  LOAD_ALUMNI_STREAM_RECOMMENDATIONS (state, payload) {
    state.alumniStreamRecommendations = payload
  },
  LOAD_ADVISOR_STREAM_RECOMMENDATIONS (state, payload) {
    state.advisorStreamRecommendations = payload
  }
}



// WEBPACK FOOTER //
// ./src/app/stream/vuex/mutations.js